import { BirthDayFormResult, QuoteInitialForm } from '@lib/data/typesQuestions';
import { dateToUnixTimestamp, unixTimestampToDate } from 'helpers';
import FormField from 'components/atoms/FormField';
import GridBox from 'components/atoms/GridBox';
import TextField from 'components/atoms/TextField';
import OnboardingButtonBar from 'components/molecules/button-bar/OnboardingButtonBar';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface Props {
  onSubmit: (data: BirthDayFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const BirthDayForm: FC<Props> = ({ onSubmit, loading, item }) => {
  const { register, handleSubmit, errors } = useForm<{ birthday: string }>();

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        const [day, month, year] = data.birthday.split('/').map(Number);

        if (item.conductor)
          onSubmit({
            conductor: {
              ...item.conductor,
              birthday: dateToUnixTimestamp(new Date(year, month - 1, day)),
            },
          });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }}>
            <TextField
              placeholder="00/00/0000"
              name="birthday"
              defaultValue={
                item.conductor?.birthday
                  ? unixTimestampToDate(
                      item.conductor.birthday,
                    ).toLocaleDateString('pt-BR', {
                      month: '2-digit',
                      day: '2-digit',
                      year: 'numeric',
                    })
                  : ''
              }
              type="tel"
              autoComplete="bday"
              errorMessage={errors.birthday?.message}
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              inputRef={register({
                required: 'Precisamos da sua data de nascimento',
                validate: {
                  valid: (date: string) => {
                    try {
                      const [day, month, year] = date.split('/').map(Number);

                      if (day > 31 || month > 12 || year < 1900)
                        return 'Data de nascismento inválida';

                      const d = new Date(year, month - 1, day);

                      const now = new Date();
                      now.setFullYear(now.getFullYear() - 18);

                      if (now.getTime() < d.getTime())
                        return 'Você precisa ter mais de 18 anos para cotar o seguro';

                      return true;
                    } catch (error) {
                      console.log(error);
                      return 'Data de nascismento inválida';
                    }
                  },
                },
              })}
            />
          </FormField>
        </GridBox>
      </GridBox>
      <OnboardingButtonBar loading={loading} />
    </Form>
  );
};

export default BirthDayForm;
